// removed by extract-text-webpack-plugin
module.exports = {"mockup":"_2kd0","frame":"_1xXI","content":"_1jvV"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Mockup/Mockup.scss
// module id = yHO9
// module chunks = 0